import React, { useMemo } from 'react';
import { ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';
import { HiddenContentChipProps } from './HiddenContentChip.props';
import {
  BottomChip,
  DivBottomBorder,
  DivLeftBorder,
  DivRightBorder,
  DivTopBorder,
  LeftChip,
  RightChip,
  Root,
  TopChip,
} from './HiddenContentChip.styles';

const HiddenContentChip = ({ id = '', isVisible = false, label = 'Read More', position }: HiddenContentChipProps) => {
  const borderComponent = useMemo(() => {
    switch (position) {
      case 'top':
        return DivBottomBorder;
      case 'right':
        return DivLeftBorder;
      case 'bottom':
        return DivTopBorder;
      case 'left':
        return DivRightBorder;
      default:
        return DivBottomBorder;
    }
  }, [position]);

  const ChipComponent = useMemo(() => {
    switch (position) {
      case 'top':
        return TopChip;
      case 'right':
        return RightChip;
      case 'bottom':
        return BottomChip;
      case 'left':
        return LeftChip;
      default:
        return BottomChip;
    }
  }, [position]);

  if (!isVisible) {
    return null;
  }

  const Border = borderComponent;
  const ChipStyled = ChipComponent;

  return (
    <Border id={id} data-testid={id}>
      <Root>
        <ChipStyled icon={<ArrowDownwardIcon />} label={label} color="primary" size="small" />
      </Root>
    </Border>
  );
};

export default HiddenContentChip;
